export default __webpack_public_path__ + "static/media/product-list-color.bd82fce9.svg";